export default __webpack_public_path__ + "static/incentive-7bf0db155c2215cdb3026aaf2f55f1c9.svg";